import { managerIndividual, ownerIndividuals } from '@banking/api/models/onboarding/individual';
export let State;
(function (_State) {
  let DialogScreen = /*#__PURE__*/function (DialogScreen) {
    DialogScreen["AddManager"] = "ADD_MANAGER";
    DialogScreen["AddOwner"] = "ADD_OWNER";
    DialogScreen["EditManager"] = "EDIT_MANAGER";
    DialogScreen["EditOwner"] = "EDIT_OWNER";
    return DialogScreen;
  }({});
  _State.DialogScreen = DialogScreen;
})(State || (State = {}));
const INITIAL_STATE = {
  businessName: '',
  requireManager: false,
  hasSignificantOwners: false,
  individuals: [],
  showAddIndividualsValidation: false,
  done: false
};
export const createState = (overrides = {}) => ({
  ...INITIAL_STATE,
  ...overrides
});
export function requiredManagersPresent(state) {
  const manager = managerIndividual(state.individuals);
  return state.requireManager ? Boolean(manager) : true;
}
export function requiredOwnersPresent(state) {
  const owners = ownerIndividuals(state.individuals);
  return state.hasSignificantOwners ? owners.length > 0 : true;
}
export function requiredIndividualsPresent(state) {
  return requiredManagersPresent(state) && requiredOwnersPresent(state);
}